<template>
  <div class="about">
    <combanner></combanner>
    <div class="about-upper com-upper-switch1 com-padding-top-30">
      <router-link :to="{name: 'prodcatalogue' }" class="dp-a1">
        <i class="iconfont icon-chanpinmulu"></i><b>Product catalogue</b>
      </router-link>
      <router-link :to="{name: 'proddata' }" class="dp-a1">
        <i class="iconfont icon-qiyeziliao"></i><b>Product information</b>
      </router-link>
      <router-link :to="{name: 'prodvideo' }" class="dp-a1">
        <i class="iconfont icon-shipin"></i><b>Product video</b>
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">

</style>
